
import { Integration, SDK } from '@commercetools/frontend-sdk';
import { getProjectActions, ProjectActions } from './actions/ProjectActions';
import { getProductActions, ProductActions } from './actions/ProductActions';
import { getCartActions, CartActions } from './actions/CartActions';
import { getWishlistActions, WishlistActions } from './actions/WishlistActions';
import { AccountActions, getAccountActions } from './actions/AccountActions';
import { ComposableCommerceEvents } from '../types/events/ComposableCommerceEvents';
import { StoreActions } from '../types/actions/StoreActions';
import { getStoreActions } from './actions/StoreActions';
import { getMediaClipActions } from './actions/MediaClipActions';
import { MediaclipActions } from '../types/actions/MediaClipActions';
class ComposableCommerce extends Integration<ComposableCommerceEvents> {
  constructor(sdk: SDK<ComposableCommerceEvents>) {
    super(sdk);

    this.project = getProjectActions(sdk);
    this.product = getProductActions(sdk);
    this.cart = getCartActions(sdk);
    this.wishlist = getWishlistActions(sdk);
    this.account = getAccountActions(sdk);
    this.store = getStoreActions(sdk);
    this.mediaClip = getMediaClipActions(sdk);
  }

  project: ProjectActions;
  product: ProductActions;
  cart: CartActions;
  wishlist: WishlistActions;
  account: AccountActions;
  store: StoreActions;
  mediaClip: MediaclipActions;
}

export { ComposableCommerce };
